module.exports = __webpack_public_path__ + "static/img/14000807.29d80d02.png";